import { chain } from 'lodash';
import type { RouteRecordRaw } from 'vue-router';

export function loadRoutes() {
    // Get all .routes.ts files within app
    const routes = import.meta.glob<RouteRecordRaw[]>(['../../modules/**/*.routes.ts'], {
        import: 'default', eager: true
    });

    return chain(routes).values()
        .flatten()
        .value();
}

export function prefixRouteNames(prefix: string, routes: RouteRecordRaw[]): RouteRecordRaw[] {
    return routes.map((route) => {
        const prefixedRoute = {
            ...route,
            name: `${prefix}-${String(route.name)}`,
        };

        if (route.children) {
            prefixedRoute.children = prefixRouteNames(prefix, route.children);
        }

        return prefixedRoute;
    });
}
